import * as yup from "yup";
import { validationNotEmpty, } from "./defaultValidations";

export default yup.object({
  keyType: validationNotEmpty("Key Type"),
  pemFile: validationNotEmpty("File"),
  labelName: validationNotEmpty("Label Name"),
});